import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'


import Landing from './containers/landingPage/index'
import Main from './containers/main/index'

import { PrivateRoute } from './helpers/PrivateRoute'

import { Provider } from 'react-redux'
import store from './store/index'

import Myprovider from './contextProvider/ContextProvider'

class App extends Component {

  render() {
    return (
      <Myprovider>
        <Provider store={store}>
          <Router>
            <Switch>
              <PrivateRoute path='/main' component={Main} />
              <Route path='/' exact component={Landing} />
              <Route component={()=><h1>error 404</h1>}/>
            </Switch>
          </Router>
        </Provider>
      </Myprovider>
    );
  }
}

export default App;
